<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent width="80%">
      <v-card>
        <v-card-title>
          <span class="headline">Participantes da Atividade Extra</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md2>
                <v-text-field color="primary" label="Data" disabled :value="atividade.data"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field color="primary" label="Dia Semana" disabled :value="atividade.diaSemana"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field color="primary" label="Qtde Horas" disabled :value="atividade.qtdeHora"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-text-field color="primary" label="Descrição" disabled :value="atividade.descricao"></v-text-field>
              </v-flex>
            </v-layout>
            <v-divider class="my-3"></v-divider>
            <div class="qh-atv-extra-participantes-scroll">
              <v-data-table :loading="loading" :headers="headers" :items="participantes" class="elevation-1" hide-actions>
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.numeroRegistro }}</td>
                  <td>{{ props.item.nome }}</td>
                  <td>{{ props.item.funcao }}</td>
                </template>
                <template slot="no-data">
                  Sem participantes nessa atividade.
                </template>
              </v-data-table>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click.native="close">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import qhAtvExtraService from "@/service/qh/QhAtvExtraService";
import EventBus from "@/utils/EventBus";
export default {
  name: "ModalParticipantesQhAtvExtra",
  data() {
    return {
      dialog: false,
      loading: false,
      atividade: {},
      participantes: [],
      headers: [
        { text: "Nr Registro", align: "left", sortable: false, value: "numeroRegistro" },
        { text: "Nome", align: "left", sortable: false, value: "nome" },
        { text: "Função", align: "left", sortable: false, value: "funcao" }
      ]
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    EventBus.$on("verParticipantesQhAtvExtra", async atividade => {
      this.atividade = atividade || {};
      this.loading = true;
      this.participantes = await qhAtvExtraService.listarParticipantes(this.atividade.id);
      this.loading = false;
      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.atividade = {};
        this.participantes = [];
      }, 300);
    }
  }
};
</script>
<style scoped>
.qh-atv-extra-participantes-scroll {
  max-height: 320px;
  overflow-y: auto;
}
</style>
